/**
 * Wandelt ein leeres Datums-Eingabefeld ('' / Whitespace / null / undefined) in `null` um.
 *
 * Hintergrund: HTML-`<input type="date">` liefert bei leerem Feld einen Leerstring `''`.
 * Postgres `date`-Spalten lehnen den ab → "invalid input syntax for type date: \"\"".
 * Gültige Werte bleiben unverändert (getrimmt).
 */
export function leeresDatumZuNull(value: string | null | undefined): string | null {
  if (value == null) return null;
  const t = value.trim();
  return t === '' ? null : t;
}

/**
 * Wandelt ein leeres ID-Feld ('' / Whitespace / null / undefined) in `null` um.
 *
 * Hintergrund: Auswahlfelder (Objekt-Suche, Einheiten-Dropdown) halten „nichts gewählt"
 * als Leerstring `''` im Formularstand. Postgres `uuid`-Spalten lehnen den ab →
 * "invalid input syntax for type uuid: \"\"" (Vorfall 2026-08-26: Mieter ohne Objekt
 * liess sich nicht anlegen). Gültige IDs bleiben unverändert (getrimmt).
 */
export function leereIdZuNull(value: string | null | undefined): string | null {
  if (value == null) return null;
  const t = value.trim();
  return t === '' ? null : t;
}
